import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';
import { Spacer } from '@kizen/kds/Spacer';

type ConfirmPlanChangesDialogProps = {
  modalProps: any;
  billingPreviewResponse?: any;
};

export const ConfirmPlanChangesDialog = (
  props: ConfirmPlanChangesDialogProps
) => {
  const { t } = useTranslation();

  const { modalProps, billingPreviewResponse } = props;

  return (
    <Modal {...modalProps} heading={t('Confirm Plan Changes')}>
      <div className="pb-2">
        <Typography>
          {t(
            'Please Confirm the requested changes to your plan and agree to the new charges.'
          )}
        </Typography>
        <Spacer size={20} />
        <Typography>
          <strong>{t('New monthly total:')}</strong> $
          {billingPreviewResponse?.monthly_cost_summary?.total}/{t('mo')}
        </Typography>
        <Spacer size={10} />
        <Typography>
          <strong>{t('Amount billed today:')}</strong> $
          {
            +(
              Math.round(
                Number(
                  (billingPreviewResponse?.upgrade_cost_summary?.total ?? 0) +
                    'e+2'
                )
              ) + 'e-2'
            )
          }
        </Typography>
      </div>
    </Modal>
  );
};
